export const TOGGLE_LOADING = 'admin/tableManager/TOGGLE_LOADING'
export const GET_TABLE_PERMISSIONS = 'admin/tableManager/GET_TABLE_PERMISSIONS'
export const GET_ADDITIONAL_FIELDS_TABLE_PERMISSIONS = 'admin/tableManager/GET_ADDITIONAL_FIELDS_TABLE_PERMISSIONS'
export const EDIT_ADDITIONAL_FIELDS_TABLE_PERMISSIONS = 'admin/tableManager/EDIT_ADDITIONAL_FIELDS_TABLE_PERMISSIONS'
export const SET_TABLE_PERMISSIONS = 'admin/tableManager/SET_TABLE_PERMISSIONS'
export const EDIT_TABLE_PERMISSIONS = 'admin/tableManager/EDIT_TABLE_PERMISSIONS'
export const SET_PERMISSIONS = 'admin/tableManager/SET_PERMISSIONS'
